import { useDispatch } from "react-redux";

import { sendTemplate } from "pages/HandBook/model/thunks";
import { IHandBookTemplate } from "pages/HandBook/model/types";

import { ReactComponent as DownloadIcon } from "./../../assets/download.svg";
import { useTypedSelector } from "app/store/typedUseSelector";
import { useConfirmModal } from "entities/ConfirmationModal/ConfirmationContext";
import Spinner from "shared/ui/atoms/Spinner/Spinner";

import { useTypedParams } from "utils/hooks/useTypedParams";
import { useUrlModule } from "utils/hooks/useUrlModule";

import { generateStorageKey } from "utils/helpers/generateStorageKey";

import styles from "./HandBookApplyToObject.module.scss";

interface IProps {
  template: IHandBookTemplate;
}

const HandBookApplyToObject = ({ template }: IProps) => {
  const dispatch = useDispatch();
  const routeModule = useUrlModule();
  const { objectId } = useTypedParams();

  /*   const objectIdForApply = useMemo(() => {
    const locationUrl = new URL(window?.location?.href);
    const idCandidate = locationUrl?.searchParams?.get("objectIdForApplyTemplate");
    if (routeModule === "objects" && !idCandidate) {
      return objectId;
    }
    return idCandidate;
  }, [routeModule, objectId]); */

  const locationUrl = new URL(window?.location?.href);
  const objectIdForApply = locationUrl?.searchParams?.get("objectIdForApplyTemplate");
  const objectName = locationUrl?.searchParams?.get("objectNameForApplyTemplate");

  const isPending = useTypedSelector(
    (state) =>
      state.handBookReducer.loadings[generateStorageKey({ type: "send", id: template.id, objectId: objectIdForApply! })]
  );

  const { openConfirmModal, closeConfirmModal } = useConfirmModal();

  const openDialog = () => {
    openConfirmModal({
      isOpen: true,
      onClose: closeConfirmModal,
      action: () => {
        closeConfirmModal();
        dispatch(
          sendTemplate({
            objectId: objectIdForApply as string,
            templateId: template.id,
          })
        );
      },
      title: "Подтвердите действие",
      acceptButtonText: "Загрузить",
      className: styles.confirmModal,
      children: `Вы действительно хотите выгрузить шаблон ${template.name} на объект ${objectName || objectIdForApply}`,
    });
  };

  if (!objectIdForApply) return null;

  if (isPending) return <Spinner isSmallGray isStatic />;

  return (
    <button
      className={styles.btn}
      onClick={(e) => {
        e.stopPropagation();
        openDialog();
      }}
    >
      <DownloadIcon />
    </button>
  );
};

export default HandBookApplyToObject;
